import { Routes, Route, Navigate } from "react-router-dom";

//
import AuthLoader from "../services/context/auth/AuthLoader";
// import IsAuth from "../services/auth/IsAuth";
// import IsGuest from "../services/auth/IsGuest";

// layouts
import MainLayout from "../layouts/main";
import AuthLayout from "../layouts/auth";
import LessonLayout from "../layouts/lesson";

// pages
import Home from "../modules/main/container/HomeHOC";
import About from "../modules/main/container/AboutHOC";
import Login from "../modules/auth/container/LoginHOC";
import Register from "../modules/auth/container/RegisterHOC";
import Forgot from "../modules/auth/container/ForgotHOC";
import Lesson from "../modules/lesson/container/LessonHOC";
import Course from "../modules/main/container/CourseHOC";
// import Cabinet from "../modules/system/Cabinet";

export default function Router() {
  return (
    <AuthLoader>
      {/* <IsAuth>
        <Routes>
          <Route path="/" element={<Cabinet />} />
          <Route path="*" element={<Navigate to={"/"} />} />
        </Routes>
      </IsAuth> */}
      {/* <IsGuest> */}
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/curse/:id" element={<Course />} />
        </Route>
        <Route path="/auth" element={<AuthLayout />}>
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot" element={<Forgot />} />
        </Route>
        <Route path="/lesson" element={<LessonLayout />}>
          <Route index element={<Lesson />} />
        </Route>
        <Route path="*" element={<Navigate to={"/"} />} />
      </Routes>
      {/* </IsGuest> */}
    </AuthLoader>
  );
}
